import React, { ReactElement } from "react";
import styled from "styled-components/macro";

const FooterDiv = styled.div`
	position: fixed;
	left: 6px;
	bottom: 3px;
	overflow: hidden;
	font-size: 12px;
	color: #333;
`;

function Footer(): ReactElement {
	return <FooterDiv className="noselect">© 2022 Lowe&apos;s. All rights reserved.</FooterDiv>;
}

export default Footer;
